<template>
    <tr v-if="isSplit">
      <td></td>
      <td></td>
      <td>
        <input
            :min="0"
            placeholder="0"
            type="number"
            class="form-control max-number-width"
            v-model.number="splitObj.quantity"
          />
      </td>
      <td>
      </td>
      <td>
        <input
            :min="0"
            placeholder="0"
            type="number"
            class="form-control max-number-width"
            v-model.number="splitObj.cost"
          />
      </td>
      <td>
        <input v-model="splitObj.dateCode" class="form-control" />
      </td>
      <td>
        <input v-model="splitObj.lotCode" class="form-control" />
      </td>
      <td>
        <input v-model="splitObj.revision" class="form-control" />
      </td>
      <td>
        <b-form-select
            v-model="splitObj.conditionId"
            class="form-control"
          >
            <option
              v-for="condition in sortSelect(conditions)"
              :key="condition.id"
              :value="condition.id"
            >
              {{ condition.name }}
            </option>
          </b-form-select>
      </td>
      <td>
        <b-form-select
            v-model="splitObj.countryOfOriginId"
            style="max-width:150px">
            <option
              v-for="countryCode in sortSelect(countryCodes)"
              :key="countryCode.id"
              :value="countryCode.id"
            >
              {{ countryCode.name }}
            </option>
          </b-form-select>
      </td>
      <td>
        <input v-model="splitObj.comments" class="form-control" />
      </td>
      <td>
        <b-button class="form-control" v-b-modal="generateRefSN" >S/N</b-button>
        <b-modal
          size="lg"
          :id="generateRefSN"
          :ref="generateRefSN"
          ok-title="Save">
          <template slot="modal-header">
            <h5 class="modal-title">Serial Numbers</h5>
          </template>
          <b-textarea v-model="splitObj.serialNumbers"></b-textarea>
        </b-modal>
      </td>
      <td>
        <b-button class="form-control"><i class="fa fa-image" /></b-button>
      </td>
    </tr>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import moment from 'moment';

import { DATE_FORMAT } from '@/shared/constants';

export default {
  props: {
    splitObj: {
      type: Object,
      default: () => {},
    },
    isSplit: {
      type: Boolean,
      default: true,
    },
    ndx: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },

    }
  },
  computed: {
    ...mapGetters('lookup', [ 'conditions', 'countryCodes' ]),
    generateRefSN() {
      return 'serial-num-modal-split-'+this.ndx;
    },
  },
  watch: {
    'splitObj.quantity': {
      handler: function(newVal, oldVal) {
        this.$emit('onSplitQuantityChange', { newVal, oldVal }) ;
      },
      deep: true
    },
  },
}
</script>

<style scoped>
  .input-disabled {
    border-left: 0px;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    background: none;
  }
  .disabled-button {
    color: #dddddd !important;
    cursor: context-menu;
  }
  .highlight-field {
    border-color: rgb(1678484);
  }
  .max-number-width {
    width: 80px;
  }
  td {
    padding-left: 5px;
  }
</style>